import * as api from 'commons/js/api'

export function getIpCountry () {
    return api.getIpCountry()
}
